module.exports = __webpack_public_path__ + "static/media/PayPal.41c0aa9b.png";